var _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.45217,
    cy: 8.45217,
    r: 8.45217,
    fill: "currentColor",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7217,
    cy: 17.4678,
    r: 3.94435,
    fill: "currentColor",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.835,
    cy: 10.7061,
    r: 1.69043,
    fill: "currentColor",
    opacity: 0.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVo2);
export default __webpack_public_path__ + "static/media/Vo2.f4c368be4a281e1268c9791f4e0466b6.svg";
export { ForwardRef as ReactComponent };